import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'woo-progress-bar',
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar {
  progress = input<number>(0);
  displayProgress = computed(() => {
    if (this.progress() <= 100) {
      return this.progress();
    }
    return 100;
  });
}
